import { render } from "./Quotes.vue?vue&type=template&id=ba62cfe2"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__